<template>
    <div class="mb-4">
        <p>Type</p>
        <select class="form-select hero-type-select mb-4" name="item_type" v-model="this.Type" @change="this.UpdateItemList()">
            <option></option>
            <option value="event">Event</option>
            <option value="altlan">altLAN</option>
            <option value="item">Item</option>
            <option value="blog">Blog</option>
            <option value="podcast">Podcast</option>
        </select>
        <p>Item</p>
        <select class="form-select hero-item-select" name="item_id">
            <option v-for="Item in Items" :value="Item.id">{{ Item.name }}</option>
        </select>
    </div>
</template>

<script>

export default {

    data () {
        return {
            Type: "",
            Items: []
        }
    },

    created () {
        //
    },

    computed: {
        //
    },

    methods: {
        UpdateItemList () {
            if ( this.Type == "" ) return;
            axios.post('/admin/items_by_type', {
                type: this.Type
            }).then( (response) => {
                if ( response.data.items.length == 0 ) return;
                this.Items = response.data.items;
            }).catch( (error) => {
                console.log(error);
            });
        }
    }

}
</script>